import type { RouteLocationRaw } from 'vue-router';

import { projectApiParam, type ProjectRouteRef } from './project-route';

/** Minimal company identity for building /:companyId links. */
export type CompanyRouteRef = { number: number; id?: string } | { id: string; number?: number };

/** Public segment for /:companyId — numeric id when present, else legacy UUID. */
export function companyDetailsParam(company: CompanyRouteRef): string {
  if ('number' in company && company.number !== undefined && company.number !== null) {
    return String(company.number);
  }
  if ('id' in company && company.id) return company.id;
  throw new Error('Company route ref must include number or id');
}

/** Build a company-details route using the public numeric id. */
export function companyDetailsTo(
  company: CompanyRouteRef,
  query?: Record<string, string | undefined>,
): RouteLocationRaw {
  return {
    name: 'company-details',
    params: { companyId: companyDetailsParam(company) },
    ...(query ? { query } : {}),
  };
}

export function companyProjectsSectionTo(
  company: CompanyRouteRef,
  options: { project: ProjectRouteRef },
): RouteLocationRaw {
  return {
    name: 'company-projects-section',
    params: {
      companyId: companyDetailsParam(company),
      projectId: projectApiParam(options.project),
    },
  };
}

export function companyNotesSectionTo(company: CompanyRouteRef): RouteLocationRaw {
  return {
    name: 'company-notes-section',
    params: { id: companyDetailsParam(company) },
  };
}

export function companyCheckinDetailsTo(
  company: CompanyRouteRef,
  ruleId: string,
): RouteLocationRaw {
  return {
    name: 'company-checkin-details',
    params: { id: companyDetailsParam(company), ruleId },
  };
}
